import service from '@/services/importReviews';
import { CONSTS } from '@/helpers/consts';

export default {
  loadImportEntries({ state, commit }) {
    return service.getImportEntries(state.importEntries.pagination).then(res => {
      return commit('loadImportEntriesSuccess', res);
    });
  },
  closeErrorMessage({ commit }, entryId) {
    service.closeErrorMessage(entryId).then(res => {
      return commit('closeErrorMessageSuccess', res);
    });
  },
  getImportEntryStatus({ commit }, importId) {
    service.getImportDeleteStatus(importId).then(res => {
      return commit('setImportDeleteStatus', res);
    });
  },
  setPagination({ commit }, payload) {
    return commit('setPagination', payload);
  },
  setImportEntries({ commit }, payload) {
    return commit('setImportEntries', payload);
  },
  loadUnlinkedImports({ state, commit }) {
    return service.getUnlinkedImports(state.unlinkedImportEntries.pagination).then(res => {
      return commit('loadUnlinkedImportEntriesSuccess', res);
    });
  },
  setUnlinkedPagination({ commit }, payload) {
    return commit('setUnlinkedPagination', payload);
  },
  loadUnlinkedReviews({ state, commit }, payload) {
    service.getUnlinkedAmazonReviews(state.unlinkedReviews.pagination, payload).then(res => {
      return commit('loadUnlinkedReviewsSuccess', res);
    });
  },
  setUnlinkedReviewsPagination({ commit }, payload) {
    return commit('setUnlinkedReviewsPagination', payload);
  },
  setImportForm({ commit }, payload) {
    return commit('setImportForm', payload);
  },
  resetImportForm({ commit, rootState }, reviewSource) {
    const serviceKey = Object.keys(CONSTS.service).find(
      key => CONSTS.service[key] === reviewSource
    );
    const profile = rootState.accountInfo.importerProfiles[serviceKey];
    const form = {
      marketplaceId: null,
      sellerId: null,
      importExternalId: null,
      region: null,
      howManyReviews: null,
      howManyRatings: null,
      reviewStarSubset: 1,
      translateReviews: null,
      autoApprove: false,
      importEntryId: null,
      importOnlyWithImages: false,
      importRatings: false,
      minimumWords: null,
      obfuscateReviewerName: false,
    };

    if (profile) {
      form.translateReviews = profile.translateReviews;
      form.howManyReviews = profile.howManyReviews;
      form.howManyRatings = profile.howManyRatings || null;
      form.minimumWords = profile.minimumWords || null;
      form.importOnlyWithImages = profile.importOnlyWithImages;
      form.obfuscateReviewerName = profile.obfuscateReviewerName;
    }
    if (reviewSource === CONSTS.service.amazon) {
      form.importRatings = profile.importRatings;
    }
    return commit('setImportForm', form);
  },
  importReviews({ state }, reviewSource) {
    if (state.importForm.importEntryId) {
      return service.editImport(state.importForm).then(() => {});
    } else if (reviewSource == CONSTS.service.amazonSeller) {
      return service.importAmazonSellerReviews(state.importForm).then(() => {});
    } else if (reviewSource == CONSTS.service.ebaySeller) {
      return service.importEbaySellerReviews(state.importForm).then(() => {});
    } else {
      return service.newImportReviews(state.importForm, reviewSource).then(() => {});
    }
  },
  deleteImportedReviews({ dispatch, commit }, importId) {
    service
      .deleteImportedReviews(importId)
      .then(() => {
        commit('setImportDeleteStatus', { data: { deleted: null } });
        dispatch('loadAccountInfo', {}, { root: true });
      })
      .then(() => {
        dispatch('loadImportEntries');
      });
  },
  loadImportsTable: ({ commit }, productId) => {
    return (
      service
        .getProductReviewsTable(productId)
        .then(response => commit('loadImportsTableSuccess', response))
        //eslint-disable-next-line no-console
        .catch(err => console.error(err))
    );
  },
  syncLatestReviews({ dispatch }, importId) {
    return service.syncLatestImports(importId).then(() => {
      dispatch('loadAccountInfo', {}, { root: true });
    });
  },
  retryImportEntry({ dispatch }, importId) {
    return service.retryImport(importId).then(() => {
      dispatch('loadAccountInfo', {}, { root: true });
    });
  },
  changeAutoSyncStatus({ dispatch }, importId) {
    return service.changeAutoSyncStatus(importId).then(() => {
      dispatch('loadImportEntries');
    });
  },
};
